module.exports = __webpack_public_path__ + "img/img.00842ca0.png";